<script>
import { mapGetters } from 'vuex';

import {
  AGUAS_ANDINAS,
  GORE_VALPARAISO,
  MACHALI,
  INH,
  SISS,
  U_AYSEN
} from '@/constants/companies';

export const RepositoriesCustomTypeMixin = {
  data() {
    return {
      options: [
        { value: 'AF', text: 'Acta de fiscalización' },
      ],
      optionsAguasAndinas: [
        { value: 'ADP', text: 'Aumento de Plazo' },
        { value: 'SV', text: 'Solicitudes Varias' },
      ],
      optionsGore: [
        { value: 'ACUCORE', text: 'Acuerdo CORE' },
        { value: 'BIT', text: `Bitácora ${new Date().getFullYear()}` },
        { value: 'MEMO', text: 'Memorándum' },
        { value: 'OF', text: 'Oficio' },
        { value: 'OFCORE', text: 'Oficio CORE' },
        { value: 'ODP', text: 'Orden de Pago con Cargo a Gasto de Representación' },
        { value: 'RES', text: 'Resolución Exenta' },
        { value: 'RESUGDPS', text: 'Resolución Exenta UGDP-S' },
        { value: 'SP', text: `Solicitud de Presupuesto ${new Date().getFullYear()}` },
        { value: 'SCP', text: 'Solicitud Compra de Pasajes' },
        { value: 'INF', text: 'Informe de uso y custodia de vehículos fiscales' },
        { value: 'SOGR', text: 'Solicitud Gasto de Representación' },
        { value: 'SEGR', text: 'Selección Proveedor Gasto de Representación' },
        { value: 'IDPC', text: 'Informe de Desempeño Proceso de Calificaciones' },
      ],
      optionsUAysen: [
        { value: 'SCH', text: 'Solicitud convenio honorarios' },
        { value: 'GRC', text: 'Guía Recepción Conforme' },
        { value: 'CPSH', text: 'Convenio de prestación de servicios a honorarios' },
        { value: 'FISABS', text: 'Formulario inicial solicitud de adquisición de bienes o servicios' },
        { value: 'SCF', text: 'Solicitud de cometido de funcionario' },
        { value: 'ACT', text: 'Informe de Actividades' },
        { value: 'FCA', text: 'Formulario de Compras Adquisiones' },
      ],
      optionsSiss: [
        { value: 'AF', text: 'Acta de fiscalización' },
      ],
      optionsMachali: [
        { value: 'DA', text: 'Decreto Alcaldicio' },
        { value: 'OF', text: 'Oficio' },
        { value: 'MEMO', text: 'Memorándum' },
      ],
      optionsInh: [
        { value: 'RESINH', text: 'Resolución Exenta' },
      ]
    };
  },
  computed: {
    ...mapGetters('Empresas', [
      'company'
    ]),
    isAguasAndinasVal() {
      return this.company.iut === AGUAS_ANDINAS.iut;
    },
    isGoreVal() {
      return this.company.iut === GORE_VALPARAISO.iut;
    },
    isMachaliVal() {
      return this.company.iut === MACHALI.iut;
    },
    isUAysenVal() {
      return this.company.iut === U_AYSEN.iut;
    },
    isSissVal() {
      return this.company.iut === SISS.iut;
    },
    isInhVal() {
      return this.company.iut === INH.iut;
    },
    optionsTypeDocument() {
      if (this.isGoreVal) {
        return this.optionsGore;
      } if (this.isSissVal) {
        return this.optionsSiss;
      }
      if (this.isSissVal) {
        return this.optionsSiss;
      }
      if (this.isAguasAndinasVal) {
        return this.optionsAguasAndinas;
      }
      if (this.isUAysenVal) {
        return this.optionsUAysen;
      }
      if (this.isMachaliVal) {
        return this.optionsMachali;
      }
      if (this.isInhVal) {
        return this.optionsInh;
      }
      return this.options;
    },
  }
};
export default RepositoriesCustomTypeMixin;
</script>
